import React from 'react';
import { Modal } from '@brighterion/br-ui';
import { Trans, useTranslation } from 'react-i18next';

import styles from './MissingParameterModal.css';

type Props = {
    isOpen: boolean;
    closeModal: () => void;
    missingParams: string[];
};

const MissingParameterModal = ({ closeModal, isOpen, missingParams }: Props) => {
    const { t } = useTranslation();
    const body = (
        <Trans i18nKey='missingParamModalBody'>
            <span>This rule is using the following parameters that no longer exist:</span>
            <br />
            <ul>
                {missingParams.map((p) => (
                    <li key={p} className={styles.listItem}>
                        <span>{p}</span>
                    </li>
                ))}
            </ul>
            <span>Contact the Mastercard Customer Success team to address this issue.</span>
        </Trans>
    );
    return (
        <Modal
            isOpen={isOpen}
            closeModal={closeModal}
            closeOnClickOutside={false}
            containerClass={styles.modalContainer}
            status='error'
        >
            <Modal.Title
                id='missing-parameter-modal-title'
                title={t('Parameter No Longer Exists')}
                onClose={closeModal}
                showCloseIcon={false}
                statusIcon='error'
            />
            <div className={styles.modalBody}>{body}</div>
            <Modal.Footer
                id='missing-parameter-modal-footer'
                onAction={closeModal}
                onActionText='Back to Rules List'
                onCloseText=''
                onClose={closeModal}
            />
        </Modal>
    );
};

export default MissingParameterModal;
